import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Router from './routes';
import ThemeConfig from './theme/index.jsx';
import ScrollToTop from './components/ScrollToTop';
import './App.css';
import GoogleTranslateWidget from './components/CustomComponents/GoogleTranslate/GoogleTranslateWidget';
import { CircularProgress, Box } from '@mui/material';

const SUPERUSER = 21;

// Loading component
const LoadingFallback = () => (
  <Box sx={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    height: '100vh' 
  }}>
    <CircularProgress />
  </Box>
);

// ----------------------------------------------------------------------

function App(props) {
  const { roleId } = props;
  return (
    <ThemeConfig>
      {roleId === SUPERUSER ? <div /> : <GoogleTranslateWidget style={{ width: '100%' }} />}
      <ScrollToTop />
      <Suspense fallback={<LoadingFallback />}>
        <Router />
      </Suspense>
    </ThemeConfig>
  );
}

App.propTypes = {
  roleId: PropTypes.number
};
export default connect((store) => ({
  roleId: store.loginReducer.user_role
}))(App);
